import React from 'react'
import ReactDOM from 'react-dom/client'
import HoldingShell from './components/Holding/HoldingShell.jsx'
import './fonts.js'
import './index.css'

// Entry for holding.html: the only code a web visitor without preview access
// receives (functions/_middleware.js serves it in place of index.html). Keep
// it to the holding page and the legal pages; nothing here may import the app.

// Capture a referral link (?ref=CODE) like main.jsx does, so it is still
// credited if the visitor signs up after launch.
try {
  const refCode = new URLSearchParams(window.location.search).get('ref');
  if (refCode) localStorage.setItem('sacredmothr_referred_by', refCode);
} catch { /* storage unavailable */ }

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HoldingShell />
  </React.StrictMode>,
)
